import { t } from './i18n.js';

/**
 * Render all cells into the grid container.
 * `photos` is a Map of taskId -> image URL, `busy` a Set of taskIds being processed.
 */
export function renderGrid(container, cells, { lang, photos, busy, winning }) {
    const items = cells.map((cell, index) => {
        const item = document.createElement('li');

        item.className = 'grid__item';
        item.classList.toggle('is-winning', winning.has(index));
        item.append( cell.type === 'free'
            ? createFreeCell(cell, lang)
            : createTaskCell(cell, lang, photos.get(cell.id), busy.has(cell.id)));

        return item;
    });

    // replace the previous content in one go (e.g. after a language switch)
    container.replaceChildren(...items);
}

function createTaskCell(cell, lang, photoUrl, isBusy) {
    const wrapper = document.createElement('div');

    wrapper.className = 'cell-wrap';

    // main button: tap to add or replace a photo
    const button = document.createElement('button');

    button.type = 'button';
    button.className = 'cell';
    button.dataset.action = 'pick';
    button.dataset.taskId = cell.id;

    if (isBusy) {
        button.classList.add('is-busy');
        button.setAttribute('aria-busy', 'true');
    }

    if (photoUrl) {
        button.classList.add('cell--filled');

        const img = document.createElement('img');

        img.className = 'cell__photo';
        img.src = photoUrl;
        img.alt = cell.text[lang];
        button.append(img);
    }

    const label = document.createElement('span');

    label.className = 'cell__label';
    label.textContent = cell.text[lang]; // textContent, never innerHTML, for config data

    button.append(label);

    wrapper.append(button);

    // add separate remove button, only when there is a photo
    if (photoUrl) {
        const remove = document.createElement('button');

        remove.type = 'button';
        remove.className = 'cell__remove';
        remove.dataset.action = 'remove';
        remove.dataset.taskId = cell.id;
        remove.setAttribute('aria-label', t(lang, 'remove'));
        remove.textContent = '×';

        wrapper.append(remove);
    }

    return wrapper;
}

function createFreeCell(cell, lang) {
    const element = document.createElement('div');

    element.className = 'cell cell--free';

    if (cell.image) {
        const img = document.createElement('img');

        img.className = 'cell__photo';
        img.src = cell.image;
        img.alt = t(lang, 'free');

        element.append(img);
    }

    return element;
}
